module.exports = __webpack_public_path__ + "68ed1dac06bf0409c18ae7bc62889170.woff";


//////////////////
// WEBPACK FOOTER
// ./bower_components/bootstrap/dist/fonts/glyphicons-halflings-regular.woff
// module id = 1193
// module chunks = 0